module.exports = __webpack_public_path__ + "static/media/laugh-beam.c6705f8b.svg";